import React from 'react';
import AnnouncementBannerToneEnum from '../Enums/AnnouncementBannerToneEnum';

// The design-system announcement banner: a coloured strip with an icon tile, a title over a text (the children), and
// optional actions on the right. tone is an AnnouncementBannerToneEnum value: gold Warning (the default), red
// Critical, green Info. className is added to the banner's own classes, for its margins. It needs a .bravo-ds
// ancestor, as all design-system classes do.
export default function AnnouncementBanner({
  tone = AnnouncementBannerToneEnum.Warning,
  iconName = 'fa-solid fa-triangle-exclamation',
  title = '',
  actions = null,
  className = '',
  children = null,
}) {
  const toneClassName = tone ? ` ${tone}` : '';
  const extraClassName = className ? ` ${className}` : '';
  return (
    <div
      className={`home-announce${toneClassName}${extraClassName}`}
      role='status'
    >
      <span className='an-ic'>
        <i className={iconName} />
      </span>
      <div className='an-body'>
        <span className='an-title'>{title}</span>
        <span className='an-text'>{children}</span>
      </div>
      {actions && <div className='ms-auto align-self-center d-flex gap-2'>{actions}</div>}
    </div>
  );
}
